<template>
  <div>

    <div v-for="(day, index) in days" :style="{marginTop: ((index > 0) ? '50px' : '0px')}">
      <h3 style="font-weight: 600; font-size: 1rem; text-align: left; margin-top: 15px; margin-bottom: 3px;">{{ day }}</h3>
      <table class="table is-striped is-narrow" style="font-size: 0.85rem;">
        <tr>
          <th>&nbsp;</th>
          <th>&nbsp;</th>
          <th>#1</th>
          <th>#2</th>
          <th>Result</th>
          <th>Time</th>
        </tr>

        <tr v-for="match in sortedMatches" v-if="match.day == day && (!match.result || hideCompleted === 'no') && (!match.canSkipMatch || hideCompleted === 'no' || hideCompleted === 'completed')" :class="{'match-announced': (match.startTime && !match.endTime && !match.result), 'match-completed': (match.result && match.endTime)}">
          <td>
            <span v-if="match.scheduledTimeShort"><span :title="'Court ' + match.scheduledCourt" style="opacity: 0.75; font-size: 0.65rem; color: #ab0000;">[{{match.scheduledCourt}}] &nbsp;&nbsp;</span>{{ match.scheduledTimeShort }}</span>
          </td>

          <td><router-link :to="'/tournaments/' + tournament.id + '/events/' + (event ? event : match.event).id + '/draws'" style="color: black !important;">{{ (event ? event : match.event).shortName }} - {{ getDrawName(match) }}</router-link></td>

          <td>
            <Entry :tournament="tournament" :event="(event ? event : match.event)" :entry="fetchEntry(match, match.entry1)" :showMissing="true" :isBusy="!match.startTime && !match.result && match.entry1 && match.entry2 && isCurrentlyPlaying(match, match.entry1)" />
          </td>

          <td>
            <Entry :tournament="tournament" :event="(event ? event : match.event)" :entry="fetchEntry(match, match.entry2)" :showMissing="true" :isBusy="!match.startTime && !match.result && match.entry1 && match.entry2 && isCurrentlyPlaying(match, match.entry2)" />
          </td>

          <td class="has-text-centered">
            <button class="button is-link is-outlined is-small is-hidden-print" @click="announceMatch(match)" v-if="!match.startTime && !match.result && match.entry1 && match.entry2">Announce</button>
            <button class="button is-primary is-small is-hidden-print" @click="activateResultsModal(match)" v-if="match.startTime && !match.result && match.entry1 && match.entry2">Set result</button>
            <span v-if="match.result">{{ match.result[match.entry1] }} - {{ match.result[match.entry2] }} &nbsp;
            <b-icon class="is-hidden-print" style="cursor: pointer; opacity: 0.6; color: darkred;" pack="fas" title="Change score" icon="edit" size="is-small" @click.native="activateResultsModal(match)" />
          </span>
          </td>

          <td class="has-text-centered">{{matchDuration(match)}}
            <b-icon v-if="match.canSkipMatch" class="is-hidden-print" style="opacity: 0.6; color: darkorange; margin-left: 5px;" pack="fas" title="Have played 2+ matches" icon="adjust" size="is-small" />
            <b-icon v-if="!match.startTime && !match.result && match.entry1 && match.entry2 && (isCurrentlyPlaying(match, match.entry1) || isCurrentlyPlaying(match, match.entry2))" class="is-hidden-print" style="cursor: pointer; opacity: 0.6; color: darkorange; margin-left: 5px;" pack="fas" title="Currently playing or resting" icon="fire" size="is-small" />
          </td>
        </tr>
      </table>
    </div>




    <b-modal :active.sync="resultsModalActivated" has-modal-card>
      <MatchResultForm v-bind="resultsModalProps"></MatchResultForm>
    </b-modal>

  </div>
</template>

<script>
  import Entry from "./Entry.vue";
  import MatchResultForm from "./MatchResultForm.vue";
  import axios from '../request.js';

  export default {
    name: 'Matches',
    props: {
      matches: [ Array ],
      tournament: Object,
      event: { type: Object, required: false },
      hideCompleted: { type: String, required: false },

      autoRefresh: { type: Boolean, required: false, default: false }
    },

    data: function() {
      return {
        resultsModalActivated: false,
        resultsModalProps: {},

        timer: undefined
      }
    },

    computed: {
      sortedMatches: function() {

        let result = [];
        if (this.matches) {
          result = this.matches.slice();
          result.sort((a, b) => {

            if (!a.scheduledTimeShort && b.scheduledTimeShort) {
              return 1;
            }

            if (a.scheduledTimeShort && !b.scheduledTimeShort) {
              return -1;
            }


            if (a.timeUnix == b.timeUnix) {
              return (a.scheduledCourt - b.scheduledCourt);
            }

            return (a.timeUnix - b.timeUnix);
          });
        }

        return result;
      },

      days: function() {
        if (this.matches) {
          let daysSet = {};
          let days = [];

          this.matches.forEach(match => { if (!daysSet[match.day]) { daysSet[match.day] = match.timeUnix; days.push(match.day); } });

          days.sort((a, b) => {
            return (daysSet[a] - daysSet[b]);
          });

          return days;
        }

        return [];
      }
    },


    created: function() {
      let vm = this;

      if (this.autoRefresh) {
        this.timer = setInterval(() => {
          if (!vm.resultsModalActivated) {
            //fetch latest data and update
            if (vm.tournament && vm.tournament.id) {
              vm.$store.dispatch('updateTournament', vm.tournament.id);
            }
          }

        }, 120000);
      }
    },

    destroyed: function() {

      if (this.timer) {
        clearInterval(this.timer);
        this.timer = undefined;
      }
    },

    methods: {
      getDrawName(match) {
        let id = match.tournamentEventDrawId;
        return (this.event ? this.event : match.event).draws.filter(draw => draw.id == id)[0].name;
      },

      fetchEntry(match, entryId) {

        if (!entryId) {
          return 'TBD';
        }

        return (this.event ? this.event : match.event).entry[entryId];
      },


      isCurrentlyPlaying(match, entryId) {

        let event = (this.event ? this.event : match.event);
        if (entryId && event && event.currentlyPlaying) {
          return (event.currentlyPlaying[entryId] ? true : false);
        }
      },


      activateResultsModal(match) {
        this.resultsModalProps = {
          match: match,
          tournament: this.tournament,
          event: (this.event ? this.event : match.event)
        };

        this.resultsModalActivated = true;
      },


      matchDuration(match) {
        if (!match || !match.duration) {
          return '';
        }

        let hours = Math.floor(match.duration / 60);
        let minutes = match.duration - hours*60;

        hours = '' + hours; minutes = '' + minutes;

        if (minutes.length != 2) { minutes = '0' + minutes; }
        return hours + ':' + minutes;
      },


      announceMatch(match) {

        let vm = this;
        let tournamentId = this.tournament.id;
        let eventId = (this.event ? this.event.id : match.event.id);

        axios.post('/api/tournament/' + tournamentId + '/event/' + eventId + '/match?announce=true', {
          id: match.id
        })

             .then(function(response){
                vm.$store.dispatch('tournamentEventsChanged', { tournamentId: tournamentId, events: response.data, stayOnPage: true });
             })
             .catch(function(){});
      }
    },

    components: { Entry, MatchResultForm }
  }
</script>

<style scoped>
  table {
    min-width: 91%;
  }

  table th {
    text-align: center;
  }

  table td, table th {
    padding: 5px 11px;
    vertical-align: middle;
  }

  table.is-narrow td {
    padding-top: 0.3rem;
    padding-bottom: 0.3rem;
  }

  table td button {
    vertical-align: middle;
    padding-top: 1px;
    padding-bottom: 1px;
    height: auto;
  }



  table tr.match-announced {
    background-color: #f7f7f7;
  }

  table tr.match-completed {
    background-color: #fcfcff;
  }
</style>
